{
  "maintains": "Organisations maintaining this resource",
  "funds": "Organisations funding this resource",
  "collaborates_on": "Collaborating organisations",
  "undefined": "Organisations with other involvement",
  "associated_with": "Organisations with a non-specific association"
}
